import { preferredLanguageAtom } from '@openeducation/oe-rn-jotai-atoms';
import { useTranslator } from '@openeducation/oe-rn-providers';
import { Language } from '@openeducation/oe-rn-shared-types';
import { styled } from '@openeducation/oe-rn-themes';
import { useAtomValue } from 'jotai';
import React, { useRef, useState } from 'react';
import { useHover } from 'react-native-web-hooks';

import { OEText } from '../../atoms';
import { OETextProps } from '../../atoms/oe-text/oe-text';
import { TranslationPopup } from '../translation-popup/translation-popup';

export interface TextWithTranslationPopupProps extends OETextProps {
  text: string;
}

export function TextWithTranslationPopup({
  text,
  children,
  ...rest
}: TextWithTranslationPopupProps) {
  const [showTooltip, setShowTooltip] = useState(false);
  const textRef = useRef(null);
  const isHovered = useHover(textRef);
  const language = useAtomValue(preferredLanguageAtom);

  const { data, isLoading } = useTranslator({
    text,
    sourceLang: Language.EN,
    targetLang: language || 'pt',
    enabled: showTooltip,
  });

  return (
    <TranslationPopup
      isVisible={showTooltip}
      data={data}
      isLoading={isLoading}
      onClose={() => setShowTooltip(false)}
      text={text}
    >
      <Text
        {...rest}
        ref={textRef}
        isHovered={isHovered}
        onPress={() => setShowTooltip(true)}
      >
        {children}
      </Text>
    </TranslationPopup>
  );
}

interface TextProps {
  isHovered: boolean;
}

const Text = styled(OEText)<TextProps>`
  text-decoration-line: ${({ isHovered }) =>
    isHovered ? 'underline' : 'none'};
  text-decoration-style: solid;
`;
